import {Messages} from "./Messages";

export class NullMessages implements Messages {
    has(_key: string): boolean {
        return false; // never found
    }

    prop(key: string, ..._args: unknown[]): string {
        // this is the same behaviour as if the string is missing;
        return "[" + key + "]";
    }
}
